/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ContractRequestChangesResponse = {
  type: 'Response',
} as const;
